module.exports = __webpack_public_path__ + "img/bubble3.png";